import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-button",
    templateUrl: "./button.component.html",
    styleUrls: ["./button.component.scss"]
})
export class ButtonComponent implements OnInit, OnDestroy {
    @Output() public buttonClick: EventEmitter<void> = new EventEmitter<void>();
    @Input() public text: string = "";
    @Input() public disabled: boolean = false;
    @Input() public resetAfterEvent: boolean = false;

    @Input() public customClass: string = "";

    public isActive: boolean = false;

    public eventTimeout: any;

    private readonly DELAY_IN_MILLISECONDS: number = 700;

    constructor() {}

    ngOnInit(): void {}

    ngOnDestroy(): void {
        if (this.eventTimeout) {
            clearTimeout(this.eventTimeout);
        }
    }

    public onButtonClicked() {
        this.isActive = true;

        this.eventTimeout = setTimeout(() => {
            this.buttonClick.emit();

            if (this.resetAfterEvent) {
                this.resetButton();
            }
        }, this.DELAY_IN_MILLISECONDS);
    }

    private resetButton() {
        this.isActive = false;
    }
}
